module.exports = {
  INIT: 'init',
  PREPARED: 'prepared',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  RETURNED: 'returned',
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
};
